/**
 * Copyright Highway9 Networks Inc.
 */
import { Clock, ClockPool } from "~/types/SyncProfile";
import APIService from "./APIServices";

// Clock Pools API Service
const clockPoolAPI = new APIService<ClockPool>("clockpools");

export const clockPoolService = {
    getAll: clockPoolAPI.getAll,
    create: clockPoolAPI.create,
    update: clockPoolAPI.update,
    delete: clockPoolAPI.delete,
    getById: async (id: string) => clockPoolAPI.get<ClockPool>(id),
};

// Clocks API Service (nested under clockpools)
const clockAPI = new APIService<Clock>("clockpools/clocks");

export const clockService = {
    getAll: clockAPI.getAll,
    create: clockAPI.create,
    update: clockAPI.update,
    delete: clockAPI.delete,
    getById: async (id: string) => clockAPI.get<Clock>(id),
};
